// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueTouch from 'vue-touch'
import animated from 'animate.css'
import {Lazyload} from 'vant'
import axios from 'axios'
import VConsole from 'vconsole'

Vue.config.productionTip = false
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(animated)
Vue.use(Lazyload)
Vue.prototype.$axios = axios
axios.defaults.headers['Content-Type']= 'application/x-www-form-urlencoded'

// var vConsole = new VConsole();

//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.onunload = function(){
  localStorage.removeItem("flag");
}


// WEBPACK FOOTER //
// ./src/main.js